import { nomePlataforma, type Plataforma } from '../../api/trafegoPago'
import { ColunasDiarias, type PontoDiario } from './ColunasDiarias'
import { useCoresPlataforma } from './coresPlataforma'

export type { PontoDiario }

type Props = {
  titulo: string
  pontos: PontoDiario[]
  /** Plataformas na ordem de empilhamento (de baixo para cima). */
  plataformas: Plataforma[]
  formatar: (v: number) => string
  formatarEixo: (v: number) => string
}

/** Colunas diárias com uma série por plataforma, cada uma na sua cor fixa. */
export function ColunasPorPlataforma({ plataformas, ...resto }: Props) {
  const cores = useCoresPlataforma()
  return <ColunasDiarias {...resto} series={plataformas.map((p) => ({ chave: p, nome: nomePlataforma(p), cor: cores[p] }))} />
}
